import { useEffect, useState } from "react";
// import { AdminBoardJson } from "../components/staff_components";
// import PartnerBanners from "../../components/test/partners";
// import dataJSON from "../api/carousel/main/index.json";
// import AOS from "aos";
// import "aos/dist/aos.css";
import axios from "axios";

export default function Testing() {
    const [navMenuItem, setNavMenuItem] = useState();

    const getNavItems = () => {
        const instance_stat = axios.create({
            baseURL: "https://aed.mju.ac.th/api/arch/nav/index.php",
        });
        instance_stat
            .get()
            .then((res) => {
                setNavMenuItem(res.data);
            })
            .catch((error) => {
                console.error(`nav axios err: ${error}`);
            });
    };

    function viewLoop(items) {
    //     items && items.map((val) => {
    //     // Object.entries(items).map(([key, val]) =>
    //         // return val.navTitle;
    //          console.log(val);
    //         // console.log("aa")
    // });
    }

    const viewItem = () => {
        console.log("val:", navMenuItem);
        console.log("val str:", JSON.stringify(navMenuItem));

        return (
            <>
                <code>{JSON.stringify(navMenuItem.student)}</code>
                {viewLoop(navMenuItem.student)}
            </>
        );
    };

    useEffect(() => {
        getNavItems();
        // console.log("NAV:", JSON.parse(navMenuItem));
        // console.log("NAV Type:", typeof navMenuItem);

        // eslint-disable-next-line
    }, [navMenuItem]);

    return (
        <>
            <h1>TEST PAGE : {process.env.REACT_APP_FRIEND}</h1>

            {console.log("NAV:", navMenuItem)}

            {navMenuItem && viewItem()}
        </>
    );
}
